import { HiShoppingCart } from "react-icons/hi";

const CartIcon = (props) => {
  return <HiShoppingCart className={props.className} />;
};

export default CartIcon;
